import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		// The platform options are plain labels beside their marks (VPLAT 7, 16), not the bold titles
		// DescribedRadioGroup gives a described option.
		title: {
			fontWeight: 400,
		},
	} satisfies Record<string, CSSObject>);
};
